"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const notification_1 = require("@App/api/routes/notification");
class NotificationStore {
    constructor(rootStore) {
        Object.defineProperty(this, "_notificationToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this, {
            _notificationToken: mobx_1.observable,
            clearNotificationToken: mobx_1.action,
        });
        this.rootStore = rootStore;
        this._notificationToken = '';
    }
    get notificationToken() {
        return this._notificationToken;
    }
    getNotificationToken() {
        if (this.rootStore.authStore.isLoggedIn) {
            (0, notification_1.getNotificationToken)().then((response) => {
                (0, mobx_1.runInAction)(() => (this._notificationToken = response.data.value));
            });
        }
    }
    clearNotificationToken() {
        this._notificationToken = '';
    }
}
exports.default = NotificationStore;
